__turbopack_context__.v({
  "dropdown": "SearchDropDown-module__0qEzpW__dropdown",
  "padding": "SearchDropDown-module__0qEzpW__padding",
});
